import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../shared/services/api.service';
import { UtilService } from '../../shared/services/util.service';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: false,
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  loginObj = {
    email: '',
    password: ''
  };
  errorMessage = '';
  passwordType = 'password';
  showPassword = false;

  constructor(
    private _apiService: ApiService,
    private _util: UtilService,
    private _auth: AuthService,
    private router: Router
  ) {

  }

  onLogin(formData: any) {
    const vm = this;
    if (formData.valid) {
      vm._apiService.postData('/partners/noAuth/partner-users/login', vm.loginObj).subscribe((res: any) => {
        if (res && !res.error) {
          vm._auth.setUser(res.data);
          if (res.data.isFirstLogin === true) {
            vm.router.navigate(['/app/reset-password']);
          } else {
            vm.checkMfaStatus(res.data.email);
          }
        } else {
          vm.errorMessage = res.message;
        }
      });
    }
  }

  checkMfaStatus(email: string): void {
    this._apiService.postData('/partners/auth/totp-mfa/status', { email: email }).subscribe((res: any) => {
      if (res && !res.error && res.data.isMfaEnabled) {
        this.router.navigate(['/mfa-login']);
      } else {
        this._util.navigate('/app/dashboard');
      }
    }, () => {
      this.router.navigate(['/mfa-login']);
    });
  }

  onShowPassword() {
    const vm = this;
    vm.showPassword = !vm.showPassword;
    vm.passwordType = vm.showPassword ? 'text' : 'password';
  }


}